import React from "react";



import Dashboard from "./Dashboard";
import Apps from "./Apps";
import TopBar from "./TopBar";



const Home = () => {

  return (

    <>

      <TopBar />
      <Apps />
      

    </>

  );

};



export default Home;